module.exports = __webpack_public_path__ + "static/media/background3.76d92b80.jpg";